// System
import { Button, Stack, Typography } from '@mui/material';

// Components
import { AtLocator } from '@Components/shared/locators/AtLocator';
import { useTransactionTable } from '@Modal/hooks/transaction/useTransactionTable';

export const TransactionTitle: React.FC = () => {
  const { roundTransactionsTableFilters, handleClearRoundTransactionsTableFilters } =
    useTransactionTable();
  const objectVals = Object.values(roundTransactionsTableFilters);
  const disabled = objectVals.length === 0 || objectVals.every((val) => val === undefined);

  return (
    <AtLocator type="container" name="TransactionTitle">
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <AtLocator type="readonly-text" name="Title">
          <Typography variant="h3">Round Transactions</Typography>
        </AtLocator>
        <AtLocator type="button" name="clearFilters">
          <Button
            size="large"
            variant="contained"
            disabled={disabled}
            onClick={handleClearRoundTransactionsTableFilters}
          >
            Clear filters
          </Button>
        </AtLocator>
      </Stack>
    </AtLocator>
  );
};
